import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import { styles } from './styles';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (e: any) => any;
    selected: boolean;
    children: any;
    className?: string;
    disabled?: boolean;
}
const TabButton = (props: IProps) => {
    return (<MuiButton
        fullWidth
        disabled={props.disabled}
        className={clsx(props.selected ? props.classes.tabBtnRootSelected : props.classes.tabBtnRootUnselected, props.className)}
        onClick={props.onClick}
        variant="contained">
        {props.children}
    </MuiButton>)
}


export default withStyles(styles)(TabButton)